<!--
  Type-switch over artifacts. Each `type` gets a branch; unknown types fall
  through and render nothing. Add new artifact kinds as new branches here.
-->
@for (artifact of items(); track $index) {
  @switch (artifact.type) {
    @case ("links") {
      <div class="artifact artifact-links">
        @if (artifact.title) {
          <div class="artifact-title">{{ artifact.title }}</div>
        }
        <div class="artifact-link-cards">
          @for (card of artifact.links || []; track $index) {
            <a
              class="artifact-link-card"
              [href]="card.url"
              target="_blank"
              rel="noopener noreferrer"
            >
              @if (iconOf(card); as icon) {
                <span nz-icon [nzType]="icon" nzTheme="outline" class="artifact-link-icon"></span>
              }
              <span class="artifact-link-text">
                <span class="artifact-link-label">{{ card.label }}</span>
                @if (card.description) {
                  <span class="artifact-link-desc">{{ card.description }}</span>
                }
              </span>
            </a>
          }
        </div>
      </div>
    }
    @default {
      <!-- Unknown / future types: show the raw payload rather than crashing. -->
      <pre class="artifact-unknown">{{ artifact | json }}</pre>
    }
  }
}
